import { createApi } from '@reduxjs/toolkit/query/react';
import { apiBaseUrl, baseQuery } from './configApi';

//  User_id and password are optional for a new Product, but used for update a Product
/* eslint-disable camelcase */
const apiFoodFactsSlice = createApi({
  reducerPath: 'apiFoodFacts',
  baseQuery,
  tagTypes: ['Products'],
  endpoints: (builder) => ({
    getProduct: builder.query({
      query: (barcode) => `/api/v0/product/${barcode}.json`,
      providesTags: (result, error, barcode) => [{ type: 'Products', id: barcode }],
    }),
    getProductListBySearchName: builder.query({
      query: ({ searchInput, currentPage }) => ({
        method: 'GET',
        url: `/cgi/search.pl`,
        params: {
          search_terms: searchInput,
          json: 1,
          page: currentPage,
        },
      }),
    }),
    addProduct: builder.mutation({
      query: ({ code, name, quantity, packaging, brands, ingredients, categories, labels, countries, stores }) => ({
        url: '/cgi/product_jqm2.pl',
        params: {
          code,
          product_name: name,
          generic_name: name,
          quantity,
          packaging,
          brands,
          categories,
          labels,
          countries,
          stores,
          ingredients_text: ingredients,
        },
        method: 'GET',
      }),
    }),
    addPhotoToProduct: builder.mutation({
      query: ({ formData }) => ({
        url: '/cgi/product_image_upload.pl',
        method: 'POST',
        body: formData,
      }),
    }),
    getEditProductUrl: builder.query({
      queryFn: (ean) => ({ data: `${apiBaseUrl}/product/${ean}` }),
    }),
  }),
});
/* eslint-enable camelcase */
export const { useGetProductQuery, useLazyGetProductQuery, useGetProductListBySearchNameQuery, useAddProductMutation, useAddPhotoToProductMutation, useGetEditProductUrlQuery } = apiFoodFactsSlice;

export default apiFoodFactsSlice;
